<template>
    <div class="lesson-skills">
        <h3 class="title">Vaardigheden</h3>

        <ul class="skills-list">
            <li
                class="skill-item"
                v-for="skill in skillsIn"
                :key="skill.id">
                {{ skill.name }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-manual-lesson-skills-component',
    props: {
        skillsIn: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss"></style>
